import c from "../../../utils/constants";

class userJobPreferencesController {
  constructor() {
    "ngInject"
    
  }

  hasOptedToPrimarySchool() {
    return this.options.filter(o => o.optionCategoryId === 1020 && o.valueBool).length > 0;
  }

  hasOptedToHighSchool() {
    return this.options.filter(o => o.optionCategoryId === 1021 && o.valueBool).length > 0;
  }
  
}

export default userJobPreferencesController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-job-preferences/user-job-preferences.controller.js
 **/